var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",style:({ color: _vm.color, background: _vm.background })},[_c('wrap-container',{staticClass:"w100"},[_c('footer',[_c('p',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.text),expression:"text"}],staticClass:"titulo book"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }